import { ca } from '@cian/analytics';
import { IAnalyticsUser } from '../../types/analytics';
import { formatPhoneForAnalytics } from '../formatters';

/**
 * Заполнение номера
 * https://conf.cian.tech/pages/viewpage.action?pageId=1319910433
 */
export const trackPhoneFill = (userPhone: string | null, inputPhone: string, analyticsUser: IAnalyticsUser) => {
  ca('eventSite', {
    action: 'Fill_sopr',
    category: 'newbuilding_finder',
    label: 'phone_number',
    name: 'oldevent',
    user: {
      ...analyticsUser,
      extra: {
        phone: userPhone ? formatPhoneForAnalytics(userPhone) : undefined,
        phone_fill: formatPhoneForAnalytics(inputPhone),
      },
    },
  });
};
